import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import AssistanceFundingAvailabilityPage from "@/pages/tools/AssistanceFundingAvailability";

export const Route = createFileRoute("/tools/assistance-funding-availability")({
  head: () => seoHead("/tools/assistance-funding-availability"),
  component: AssistanceFundingAvailabilityPage,
});
